import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import * as ContainerPackingAction from '../actions/ContainerPackingAction';
import ContainerPackingStore from '../stores/ContainerPackingStore';
import swal from 'sweetalert';
import * as MenuAction from '../actions/MenuAction';
import { parse } from 'date-fns/esm/fp';
import ScanDetector from '../actions/ScanDetector';


let currentPagePath;
let editArr = [] // will be used to display the edit icon if the user already added container
let clickedIndex = "";
let wedgeValue = "";
let allowScanedValue = true;
let hideGridErrMsg = true

class ContainerPackingComponent extends Component {

    constructor(props) {
        super(props);

        this.closePopUp = this.closePopUp.bind(this);
        this.addContainer = this.addContainer.bind(this);
        this.saveContainer = this.saveContainer.bind(this);
        this.bindContainers = this.bindContainers.bind(this);
        this.resetCancel = this.resetCancel.bind(this);
        //PC_CPW_267_01 Nandhini L
        this.printBtnClick = this.printBtnClick.bind(this);
        this.okClick = this.okClick.bind(this);

        this.state = {
            containerArr: [], // finally will be sent to the API will contain all the detail about shipcontainers
            displayContainerArr: [], // used to display the rows in container pop up
            orderBindArr: [],
            containerDD: [],
            orderDD: [],
            selectedOrder: "",
            hidePopUpMsg: true,
            noCntrID: "",
            selectedContainerDD: [],
            selectedItem: "",
            isFavorited: false,
            Page_ID: null,
            consolidatedArr: [],
            barcodeData: "",
            hideNoData: true,
            consolidatedArr: [],
            printerOptions: [],
            printerValue: null,
            defaultCheck: false,
            printerErrorMsg: "",

        }

    }
    componentDidMount() {

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        if (CribID == null || CribID == undefined || CribID == "" || CribID == " ") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
        }
        else {
            currentPagePath = this.props.location.pathname;
            currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
            let getFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            ContainerPackingAction.getCurrentFavPage(getFavPageBO);
            this.pageLoad()
            this.getDefaultPrinter()
        }

        ContainerPackingStore.on('PageLoadDetails', this.pageLoadResponse);
        ContainerPackingStore.on('OrderResponse', this.ChosenOrderResponse);
        ContainerPackingStore.on('SubmitResponse', this.ShippingClickResponse);
        ContainerPackingStore.on('updateFavPageContainer', this.updateFavPageResponse.bind(this));
        ContainerPackingStore.on('favpageOfContainer', this.loadFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        ContainerPackingStore.removeListener('PageLoadDetails', this.pageLoadResponse);
        ContainerPackingStore.removeListener('OrderResponse', this.ChosenOrderResponse);
        ContainerPackingStore.removeListener('SubmitResponse', this.ShippingClickResponse);
        ContainerPackingStore.removeListener('updateFavPageContainer', this.updateFavPageResponse);
        ContainerPackingStore.removeListener('favpageOfContainer', this.loadFavPageResponse);


    }

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Container Packing",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ContainerPackingAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ContainerPackingAction.deleteFavPage(deleteFavPageBO)
        }
    };

    updateFavPageResponse = () => {
        if (ContainerPackingStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ContainerPackingStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ContainerPackingStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ContainerPackingStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    getDefaultPrinter = () => {
        let printerValue = CookieService.getLocalStorageValues("printer");

        if (printerValue == undefined || printerValue == null || printerValue == "") {
            this.setState({ printerValue: "", defaultCheck: false });
        } else {
            this.setState({ printerValue: printerValue, defaultCheck: true });
        }
    }

    pageLoad = () => { // gets the data for the drop down, Divis Kumar R K, CPW-268

        let crib = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
        ContainerPackingAction.getPageLoad(crib)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }

    pageLoadResponse = () => {

        if (ContainerPackingStore.PageLoadData == "false") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in fetching data"
            });
        }
        else {

            let PageLoadResponse = JSON.parse(ContainerPackingStore.PageLoadData);
            //PC_CPW_267_19 To get printers -Nandhini L
            let cribPrinters = PageLoadResponse.printerDT;
            let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            let locPrinterNames = [];
            let PrinterValues = cribPrinters[0].PrinterName.split("|")
            if (PrinterValues.length > 0) {
                PrinterValues.map((val, index) => {
                    if (val.toLowerCase().includes(cribID.toLowerCase().trim()) && val.toLowerCase().includes("_packing_")) {


                        //if (val.toUpperCase().includes("HOUSTON")) {
                        let locPrinters = {
                            value: val,
                            label: val.replace(cribID, ""),
                        }
                        locPrinterNames.push(locPrinters);

                    };
                });
            }

            let tempOrderDD = []
            let dt = []
            {/*const uniqueSet = new Set(PageLoadResponse.orderDDData.map(item => JSON.stringify(item)));
             Convert the Set back to an array of objects
            const uniqueArray = Array.from(uniqueSet).map(item => JSON.parse(item));
            dt = uniqueArray
            dt.map((value, index) => {
                let DDObj = {
                    label: value.ORDER_NO,
                   value: value.ORDER_NO
                }
                tempOrderDD.push(DDObj)
           })*/}
            this.setState({ printerOptions: locPrinterNames })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    bindContainers = () => { // used to bind the containers pop up, Divis Kumar R K, CPW-268
        return (
            <>
                {this.state.displayContainerArr.map((value, index) => (
                    <tr key={index}>
                        <td>

                            <Select
                                id={`containerID-${index}`}
                                name="selectContainer"
                                onChange={(e) => this.onChangeHandler("CONTAINERCHANGE", e, index)}

                                value={this.state.selectedContainerDD[index] || ""}
                                options={this.state.containerDD}
                                noOptionsMessage={() => this.state.CribNoOptionMsg}
                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                className="form-control"
                                id={`quantity-${index}`}
                                placeholder="Enter quantity"
                                disabled={this.state.selectedItemQty <= 1}

                                value={this.state.displayContainerArr[index].QTY}
                                maxLength="5"
                                onChange={(e) => this.onChangeHandler("QTYCHANGE", e, index)}
                            />
                        </td>
                        <td className="text-center">
                            <span className={this.state.displayContainerArr.length === 1 ? "disabled-link" : ""}>
                                <a href="#" onClick={(e) => this.lineLevelCancel(e, index)}>
                                    <img src="images/cancel-icon.svg" alt="cancel-icon" />
                                </a>
                            </span>
                        </td>
                    </tr>
                ))}
            </>
        );
    }



    bindOrderDetails = () => { // used to bind the item of the order, Divis Kumar R K, CPW-268
        if (this.state.orderBindArr.length > 0) {
            return (
                this.state.consolidatedArr.map((value, index) => {
                    return (
                        <tr>
                            <td>{value.INV_ITEM_ID}</td>
                            {/* CPW-327 Display user name instead of user Id - Nandhini L*/}
                            <td>{value.ISA_EMPLOYEE_NAME}</td>
                            <td>{value.DESCR254}</td>
                            <td>{value.ORIG_CNTR}</td>
                            <td>{value.QTY_PICKED}</td>
                            <td class="text-center"><a href="#" alt="Add container icon" onClick={(e) => this.showContainer(e, index)}>{editArr[index] == undefined || editArr[index] == null || editArr[index] == "" ? <img src="images/add-container-icon.svg" alt="container-icon" /> : <img src="images/edit-container-icon.svg" alt="edit-container-icon" />}</a></td>
                        </tr>
                    )
                })
            )
        }
    }

    onChangeHandler = (type, event, index) => { // will be triggered during on change of all fields, Divis Kumar R K, CPW-268
        if (type === "ORDERCHANGE") { // will be triggered when the order number is changed, Divis Kumar R K, CPW-268

            let regex = SDIConstants.alphanumericRegex
            if (event.target.value == "") {
                this.setState({ barcodeData: event.target.value })
            }
            else {
                if (regex.test(event.target.value)) {
                    let uppercaseValue = event.target.value.toUpperCase();
                    this.setState({ barcodeData: uppercaseValue })
                }
            }


        } else if (type === "CONTAINERCHANGE") { // will be triggered when the container drop down is changed, Divis Kumar R K, CPW-268
            let tempselectedContainerDD = [...this.state.selectedContainerDD];
            let tempDisplayContainerArr = [...this.state.displayContainerArr];
            tempselectedContainerDD[index] = event;
            tempDisplayContainerArr[index].SHIP_CNTR_ID = event.value;
            this.setState({ selectedContainerDD: tempselectedContainerDD, displayContainerArr: tempDisplayContainerArr });
        } else if (type === "QTYCHANGE") {//will be triggered when the qty is changed
            let regex = SDIConstants.quantityRegEX
            let tempDisplayContainerArr = [...this.state.displayContainerArr];
            if (event.target.value != "") {
                if (regex.test(event.target.value)) {

                    tempDisplayContainerArr[index].QTY = event.target.value;
                    this.setState({ displayContainerArr: tempDisplayContainerArr });
                }
            }
            else {
                tempDisplayContainerArr[index].QTY = event.target.value;
                this.setState({ displayContainerArr: tempDisplayContainerArr });
            }
        }

        else if (type = "printerCheck") {
            if (event.target.checked == true) {
                this.setState({ defaultCheck: event.target.checked })
            }
            else {
                this.setState({ defaultCheck: false })
            }
        }
    }

    onChangePrinter = (event) => {
        let locPrinters = {
            value: event.value,
            label: event.label
        }

        this.setState(
            { printerValue: locPrinters, printerErrorMsg: "" })
    }


    showContainer = (e, index) => {//Is used to display the container, Divis Kumar R K, CPW-268
        e.preventDefault();
        let selectedItem = this.state.consolidatedArr[index].INV_ITEM_ID;
        let selectedItemQty = this.state.consolidatedArr[index].QTY_PICKED;
        let tempDisplayContainerArr = this.state.containerArr
            .filter(container => container.INV_ITEM_ID === selectedItem)
            .map(container => ({ ...container })); // Create a shallow copy of each object

        let temp = [];
        let obj = null;

        if (tempDisplayContainerArr.length === 0) {//first row of the pop up is generated, Divis Kumar R K, CPW-268
            let shipCntr = this.state.selectedOrder + "001";
            if (selectedItemQty === 1) {
                obj = {
                    ...this.state.consolidatedArr[index],
                    SHIP_CNTR_ID: shipCntr,
                    QTY: 1
                };
            } else {
                obj = {
                    ...this.state.consolidatedArr[index],
                    SHIP_CNTR_ID: shipCntr,
                    QTY: ''
                };
            }

            tempDisplayContainerArr.push(obj);
            temp.push({ label: shipCntr, value: shipCntr });
        } else {
            tempDisplayContainerArr.forEach(value => {
                temp.push({ label: value.SHIP_CNTR_ID, value: value.SHIP_CNTR_ID });
            });
        }

        this.setState({
            selectedItem: selectedItem,
            selectedItemQty: selectedItemQty,
            displayContainerArr: tempDisplayContainerArr,
            selectedContainerDD: temp,
            initialContainerDD: [...this.state.containerDD], // Save initial state
            initialSelectedContainerDD: [...temp], // Save initial state
            hidePopUpMsg: true
        });
        clickedIndex = index;

        $('#ContainerPopUp').modal('show');
    }





    closePopUp = () => {//triggered when the close icon orr cancel icon is clicked in the pop up, Divis Kumar R K, CPW-268
        this.setState({
            hidePopUpMsg: true
        });

        $('#ContainerPopUp').modal('hide');
    }



    addContainer = () => {// will be triggered when the user clicks on add container button, Divis Kumar R K, CPW-268
        if (this.state.containerDD.length > 0) {
            let temp = [...this.state.selectedContainerDD];
            let tempDisplayContainerArr = [...this.state.displayContainerArr];
            let tempContainerDD = [...this.state.containerDD];

            // Generate new ship container ID for display
            let lastDispContainer = temp[temp.length - 1] ?.value || tempContainerDD[tempContainerDD.length - 1].value;
            let dispNumberPart = parseInt(lastDispContainer.slice(2), 10);
            let dispShipCntr = '';

            do {
                dispNumberPart++;
                dispShipCntr = `WM0${String(dispNumberPart).padStart(10, '0')}`;
            } while (temp.find(item => item.value === dispShipCntr));

            // Generate new ship container ID for containerDD
            let lastShipContainer = tempContainerDD[tempContainerDD.length - 1].value;
            let numberPart = parseInt(lastShipContainer.slice(2), 10);
            let newShipCntr = '';

            do {
                numberPart++;
                newShipCntr = `WM0${String(numberPart).padStart(10, '0')}`;
            } while (tempContainerDD.find(item => item.value === newShipCntr));

            // Create new container object
            let newRowDetails = {
                ...tempDisplayContainerArr[0], // Assuming you copy from the first row or a template
                SHIP_CNTR_ID: dispShipCntr,
                QTY: '' // Initial quantity
            };

            // Add new ship container ID to selectedContainerDD for display
            temp.push({ value: dispShipCntr, label: dispShipCntr });

            // Add new ship container ID to containerDD (all containers list)
            let newDDObj = { value: newShipCntr, label: newShipCntr };
            tempContainerDD.push(newDDObj);

            // Add new container to displayContainerArr
            tempDisplayContainerArr.push(newRowDetails);

            // Update state
            this.setState({
                displayContainerArr: tempDisplayContainerArr,
                containerDD: tempContainerDD,
                selectedContainerDD: temp
            });
        }
    }

    //WW-1409 -Vishwa S
    aggregateShipments = (shipments) => {
        const uniqueShipments = {};

        shipments.forEach(shipment => {
            const shipCntrId = shipment.SHIP_CNTR_ID;
            const invItemId = shipment.INV_ITEM_ID;
            const key = `${shipCntrId}-${invItemId}`; // Create a unique key based on both SHIP_CNTR_ID and INV_ITEM_ID

            if (uniqueShipments[key]) {
                // If the key already exists, sum the QTY
                uniqueShipments[key].QTY = (parseInt(uniqueShipments[key].QTY) + parseInt(shipment.QTY)).toString();
            } else {
                // If it's not in the object, add it
                uniqueShipments[key] = { ...shipment };
            }
        });

        // Convert the uniqueShipments object back to an array
        return Object.values(uniqueShipments);
    };

    saveContainer = () => {//will be triggered when saving the container, Divis Kumar R K, CPW-268

        // Filter out the items that match the selectedItem
        let qty = 0;

        // Sum up the quantities from displayContainerArr
        this.state.displayContainerArr.forEach(value => {
            qty += parseInt(value.QTY, 10); // Ensure quantity is parsed as an integer
        });

        // Check if the total quantity matches the selectedItemQty
        if (qty !== this.state.selectedItemQty) {
            this.setState({ hidePopUpMsg: false });
            return;
        } else {

            let tempContainerArr = this.state.containerArr.filter(item => item.INV_ITEM_ID !== this.state.selectedItem);
            let tempDisplayContainerArr = []
            // Add items from displayContainerArr to tempContainerArr, excluding those with QTY 0
            if (this.state.selectedItemQty != 0) {
                tempDisplayContainerArr = this.state.displayContainerArr.filter(value => parseInt(value.QTY, 10) > 0);
            }
            else {
                tempDisplayContainerArr = this.state.displayContainerArr
            }

            // Aggregate unique shipments from tempDisplayContainerArr
            let aggregatedDisplayContainerArr = this.aggregateShipments(tempDisplayContainerArr);

            // Push aggregated items to tempContainerArr
            tempContainerArr.push(...aggregatedDisplayContainerArr);

            editArr[clickedIndex] = "EDIT";
            
            // Update state with the new containerArr
            this.setState({ containerArr: tempContainerArr, hidePopUpMsg: true });
            $('#ContainerPopUp').modal('hide');
        }
    }


    lineLevelCancel = (e, index) => {//will be triggred when canceling in line leval, Divis Kumar R K, CPW-268
        e.preventDefault();
        const { displayContainerArr, selectedContainerDD } = this.state;

        // Clone the arrays to avoid direct state mutation
        let tempDisplayContainerArr = [...displayContainerArr];
        let tempSelectedContainerDD = [...selectedContainerDD];

        // Remove the container from displayContainerArr and selectedContainerDD
        tempDisplayContainerArr.splice(index, 1);
        tempSelectedContainerDD.splice(index, 1);

        // Update state
        this.setState({
            displayContainerArr: tempDisplayContainerArr,
            selectedContainerDD: tempSelectedContainerDD
        });
    };



    resetCancel = (type) => {//will be triggered on order level cancel, Divis Kumar R K, CPW-268

        console.log(`resetCancel triggered with type: ${type}`);
        if (type === "CANCEL") {
            $('#removePopup').modal('show');
            console.log('Show modal triggered');
        }
        else if (type === "YES") {
            this.setState({ containerArr: [] });

            editArr = []

            $('#removePopup').modal('hide');
            console.log('Hide modal and state reset triggered');
        }
    }


    shippingClick = () => {// will be clikced when user clicks on shipping button, Divis Kumar R K, CPW-268

        this.getDefaultPrinter()
        let uniqueOrderItems = [];
        this.state.consolidatedArr.forEach(item => {
            if (!uniqueOrderItems.includes(item.INV_ITEM_ID)) {
                uniqueOrderItems.push(item.INV_ITEM_ID);
            }
        });
        let uniquecontainerItem = [];
        this.state.containerArr.forEach(item => {
            if (!uniquecontainerItem.includes(item.INV_ITEM_ID)) {
                uniquecontainerItem.push(item.INV_ITEM_ID);
            }
        })
        let noCntrID = ""
        uniqueOrderItems.map((item, index) => {
            if (!uniquecontainerItem.includes(item)) {
                if (index != uniqueOrderItems.length - 1) {
                    noCntrID = noCntrID + item + ", "
                }
                else {
                    noCntrID = noCntrID + item
                }
            }
        })
        if (noCntrID == "" && this.state.containerArr.length > 0) {
            //PC_CPW_267_30 -Nandhini L
            /*let Obj = {
                Crib: this.state.containerArr[0].BUSINESS_UNIT,
                    orderNo: this.state.selectedOrder.value,
                        ItemAndContainers: this.state.containerArr
            }
            ContainerPackingAction.submitClick(Obj)
            this.setState({ hideGridErrMsg: true, noCntrID: noCntrID })
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            products.sort((a, b) => a.price - b.price);
        }
            this.state.tempContainerArr = this.state.containerArr

            this.state.tempContainerArr.sort((a, b) => {
                if (a.SHIP_CNTR_ID < b.SHIP_CNTR_ID) {
                    return -1
                }
                else if (a.SHIP_CNTR_ID > b.SHIP_CNTR_ID) {
                    return 1
                }
                else {
                    return 0
                }
            })*/
            //PC_CPW_267_29 -Nandhini L

            if (this.state.printerOptions == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Printers are not available for this crib"
                });
            }
            else {
                $('#printerLabelId').modal('show');
            }
            this.setState({ noCntrID: noCntrID })
            hideGridErrMsg = true
        }
        else {
            this.setState({ noCntrID: noCntrID })
            hideGridErrMsg = false
        }
    }

    ChosenOrderResponse = () => {
        let ChosenOrderResponse = JSON.parse(ContainerPackingStore.ChosenOrderResponse);
        let tempResponse = JSON.parse(ContainerPackingStore.ChosenOrderResponse);
        this.getDefaultPrinter()


        if (ChosenOrderResponse === "false" || ChosenOrderResponse == undefined) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in fetching Data"
            });
        } else {
            if (ChosenOrderResponse == null || ChosenOrderResponse == "" || ChosenOrderResponse.length == 0) {
                this.setState({ hideNoData: false })
            }
            else {
                let containerDDArr = [];
                let uniqItem = [];

                ChosenOrderResponse.forEach((value, index) => {
                    if (!uniqItem.includes(value.INV_ITEM_ID)) {
                        let DD = "";
                        if (index < 10) {
                            DD = value.ORDER_NO + "00" + (index + 1).toString();
                        } else {
                            DD = value.ORDER_NO + "0" + (index + 1).toString();
                        }
                        let Obj = {
                            value: DD,
                            label: DD
                        };
                        containerDDArr.push(Obj);
                        uniqItem.push(value.INV_ITEM_ID);
                    }
                });

                let tempConsolidatedArr = [];
                let consolidatedMap = new Map();

                tempResponse.forEach((item) => {
                    let itemId = item.INV_ITEM_ID;

                    if (consolidatedMap.has(itemId)) {
                        let existingItem = consolidatedMap.get(itemId);
                        existingItem.QTY_PICKED = parseInt(item.QTY_PICKED);

                        // Use a Set to track unique ORIG_CNTR values
                        let origCntrSet = new Set(existingItem.ORIG_CNTR.split(','));
                        origCntrSet.add(item.ORIG_CNTR);
                        existingItem.ORIG_CNTR = Array.from(origCntrSet).join(',');
                    } else {
                        consolidatedMap.set(itemId, {
                            ...item,
                            ORIG_CNTR: item.ORIG_CNTR.toString(),
                            QTY_PICKED: parseInt(item.QTY_PICKED)
                        });
                    }
                });

                tempConsolidatedArr = Array.from(consolidatedMap.values());
                this.setState({ containerDD: containerDDArr, orderBindArr: ChosenOrderResponse, consolidatedArr: tempConsolidatedArr, selectedOrder: tempConsolidatedArr[0].ORDER_NO, hideNoData: true });
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    };

    CancelBtnClick = () => {
        this.setState({
            barcodeData: "",
            containerArr: [],
            displayContainerArr: [],
            orderBindArr: [],
            containerDD: [],
            orderDD: [],
            selectedOrder: "",
            hidePopUpMsg: true,
            noCntrID: "",
            selectedContainerDD: [],
            selectedItem: "",
            consolidatedArr: [],
        })
    }


    orderDetailSearch = () => {
        let initialLetters = this.state.barcodeData.slice(0, 2)
        if (initialLetters.toUpperCase() == "WM") {
            let Obj = {
                orderNo: this.state.barcodeData,
                type: "ORDER",
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
            };
            ContainerPackingAction.getChosenOrder(Obj);
        }
        else {
            let Obj = {
                orderNo: this.state.barcodeData,
                type: "PICK",
                Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
            };
            ContainerPackingAction.getChosenOrder(Obj);
        }
        this.setState({
            selectedOrder: "",
            containerArr: [],
            tempContainerArr: [],
            displayContainerArr: [],
            orderBindArr: [],
            containerDD: [],
            hidePopUpMsg: true,
            noCntrID: "",
            selectedContainerDD: [],
            selectedItem: "",
            consolidatedArr: [],
            printerErrorMsg: "",
            printerValue: ""
        });
        editArr = []
        hideGridErrMsg = true
        clickedIndex = "";
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $('#printerLabelId').modal('hide');
        $('#ContainerPopUp').modal('hide');
    }

    ShippingClickResponse = () => {

        let ChosenOrderResponse = ContainerPackingStore.SubmitResponse;
        //PC_CPW_267_36 -Nandhini L
        $('#printerLabelId').modal('hide');

        if (ChosenOrderResponse == "false" || ChosenOrderResponse == false) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in inserting data"
            });

        }
        else if (ChosenOrderResponse == "printer not available") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Printers are not available for this crib"
            });
        }
        else {
            {/**swal({
                allowOutsideClick: false,
                    closeOnClickOutside: false,
                        text: "Order packed successfully"
            });
        */}
            $('#successPopupId').modal('show')

            // Ensure the selector is correct

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    //PC_CPW_267_38 Trigger when click ok button in success popup -Nandhini L
    okClick = () => {

        $('#successPopupId').modal('hide');
        //CPW-327 Re-directing Container Packing page to go to Shipping page -Nandhini L
        let OrderNo = this.state.selectedOrder
        this.setState({
            containerArr: [],
            displayContainerArr: [],
            orderBindArr: [],
            containerDD: [],
            orderDD: [],
            selectedOrder: "",
            hidePopUpMsg: true,
            noCntrID: "",
            selectedContainerDD: [],
            selectedItem: "",
            consolidatedArr: [],
            barcodeData: ""
        }, () => {
            this.pageLoad();
        });
        // Reset other variables
        editArr = [];
        clickedIndex = '';
        hideGridErrMsg = true
        //CPW-327 Re-directing Container Packing page to go to Shipping page -Nandhini L
        this.props.history.push({
            pathname: "/fedexshipping",
            state: { OrderNo: OrderNo }
        });

    }

    //PC_CPW_267_19 Trigger when click print and cancel button in printer popup-Nandhini L
    printBtnClick = (e, type) => {
        e.preventDefault()

        console.log("Printer", CookieService.getLocalStorageValues("printer"))
        if (type == "submit") {
            if (this.state.printerValue == undefined || this.state.printerValue == null || this.state.printerValue == "") {
                this.setState({ printerErrorMsg: "Please select printer" })
                return false
            }
            else if (this.state.printerValue.value == "") {
                this.setState({ printerErrorMsg: "Please select printer" })
                return false
            }
            else {
                if (this.state.defaultCheck) {
                    CookieService.updateLocalStorageValues("printer", this.state.printerValue);
                }
                else {
                    CookieService.updateLocalStorageValues("printer", "");
                }

                if (this.state.noCntrID == "" && this.state.containerArr.length > 0) {
                    let conData = this.state.containerArr.filter((v, i, a) => a.findIndex(t => (t.SHIP_CNTR_ID.trim().toUpperCase() === v.SHIP_CNTR_ID.trim().toUpperCase())) === i)

                    let Obj = {
                        Crib: this.state.containerArr[0].BUSINESS_UNIT,
                        orderNo: this.state.selectedOrder,
                        ItemAndContainers: this.state.containerArr,
                        conLength: conData.length,
                        printer: this.state.printerValue.value,
                        SHIPTO_ID: this.state.orderBindArr[0].SHIPTO_ID,
                    }
                    ContainerPackingAction.submitClick(Obj)
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                }
            }
        }
        else if (type == "cancel") {
            $('#printerLabelId').modal('hide');
            this.setState({
                printerErrorMsg: "", printerValue: "", defaultCheck: false
            })
        }
    }

    handleBarcodeScan = (value) => {
        if (value != undefined || value != null || value != "" || value.trim() != "") {
            let initialCharacters = value.slice(0, 2)
            if (initialCharacters == "WM" || initialCharacters == "CN" && value.length > 1) {
                wedgeValue = ""
                wedgeValue = value
                let uppercaseValue = value.toUpperCase();
                hideGridErrMsg = true
                this.setState({
                    barcodeData: uppercaseValue,
                    hidePopUpMsg: true,
                }, () => {
                    this.orderDetailSearch();
                });

            }
        }
    }





    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="container-fluid content-section">
                    <div className="row">
                        {/* Shopping Cart starts */}
                        <div className="container-fluid content-margin">
                            <div className="row">
                                <div className="col-md-12 page-heading mb-3">
                                    <h5 className="page-title"><Trans>Container Packing</Trans></h5>
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-a" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-a">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label>Enter pick container ID or order number or scan the barcode</label>

                                    <div class="row" >

                                        <div className="col-md-4 pl-2 ml-1">
                                            <div className="input-group charge-code-group">
                                                <input type="text" className="form-control charge-code-control" maxLength="16" placeholder="Enter Value" value={this.state.barcodeData} name="barcodeData" id="barcodeData" onChange={(e) => this.onChangeHandler("ORDERCHANGE", e, 1)} />
                                                {this.state.barcodeData != undefined && this.state.barcodeData != null && this.state.barcodeData != "" && this.state.barcodeData != " " ?
                                                    < span class="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.CancelBtnClick()} ></span> : null
                                                }
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <span className="shopping-search-icon" onClick={() => { this.orderDetailSearch() }} />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span hidden={this.state.hideNoData} className="color-validation font-12 font-regular mt-1">Please search a valid pick container ID/order number</span>



                                    <div class="row mb-4 mt-4" hidden={this.state.orderBindArr.length > 0 ? false : true}>
                                        <div class="col-md-12 mb-3">
                                            <h5 class="font-bold font-16 mb-0 mt-2">Order Info</h5>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <div class="item-box px-3 py-3">
                                                <div class="row">
                                                    <div class="col-md-4 mb-2">
                                                        <label class="font-12 font-medium label-color mb-0">Store number :</label>
                                                        <label class="ml-2 font-12 font-regular label-value-color mb-0">{this.state.orderBindArr[0] && this.state.orderBindArr[0].SHIPTO_ID != null && this.state.orderBindArr[0].SHIPTO_ID.trim() != "" ? this.state.orderBindArr[0].SHIPTO_ID : "-"} </label>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <label class="font-12 font-medium label-color mb-0">Work order :</label>
                                                        <label class="ml-2 font-12 font-regular label-value-color mb-0">{this.state.orderBindArr[0] && this.state.orderBindArr[0].ISA_WORK_ORDER_NO != null && this.state.orderBindArr[0].ISA_WORK_ORDER_NO.trim() != "" ? this.state.orderBindArr[0].ISA_WORK_ORDER_NO : "-"}</label>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <label class="font-12 font-medium label-color mb-0">Status :</label>
                                                        <label class="ml-2 font-12 font-regular label-value-color mb-0">{this.state.orderBindArr[0] && this.state.orderBindArr[0].ISA_LINE_STATUS != null && this.state.orderBindArr[0].ISA_LINE_STATUS.trim() != "" ? this.state.orderBindArr[0].ISA_LINE_STATUS == "PKP" ? "Partially picked" : "Fully picked" : "-"}</label>
                                                    </div>

                                                    <div class="col-md-12">
                                                        <label class="font-12 font-medium label-color mb-0">Delivery instructions :</label>
                                                        <label class="ml-2 font-12 font-regular label-value-color mb-0">{this.state.orderBindArr[0] && this.state.orderBindArr[0].ISA_LINE_NOTES != null && this.state.orderBindArr[0].ISA_LINE_NOTES.trim() != "" ? this.state.orderBindArr[0].ISA_LINE_NOTES : "-"}</label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div hidden={this.state.orderBindArr.length > 0 ? false : true} class="row">
                                        <div class="col-md-12 mb-3">
                                            <h5 class="font-bold font-16 mb-0 mt-2">Item Info</h5>
                                        </div>

                                        <div class="col-md-12 mb-5">
                                            <div class="table-responsive mb-3">
                                                <table class="table split-delv-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Item ID</th>
                                                            <th>Picker</th>
                                                            <th>Description</th>
                                                            <th>Pick container</th>
                                                            <th>Picked quantity</th>
                                                            <th class="text-center">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.bindOrderDetails()}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="text-right">
                                                <span hidden={hideGridErrMsg == true} className="color-validation font-12 font-regular">
                                                    The packed quantity for item(s) {this.state.noCntrID} are not equal to the picked quantity
                                            </span>

                                            </div>
                                        </div>

                                        <div class="col-md-12 mb-4">
                                            <div class="d-flex justify-content-end">
                                                <button class="btn btn-dark-grey  font-14 font-medium mr-3 px-4" onClick={() => this.resetCancel("CANCEL")}>Cancel</button>
                                                <button class="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.shippingClick()}>Shipping</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div>
                    <ScanDetector onBarcodeScan={this.handleBarcodeScan} />

                </div>
                {/*Modal Starts here*/}
                <div class="modal fade add-container-popup p-0" id="ContainerPopUp" tabindex="-1" role="dialog" data-backdrop="static" >
                    <div style={{ maxWidth: "650px" }} class="modal-dialog add-container-width" role="document">
                        <div class="modal-content border-0 mt-0">
                            <div class="modal-header sp-delv-header align-items-center">
                                <h5 class="modal-title" id="exampleModalLongTitle">Add container</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" onClick={this.closePopUp}>
                                    <img src="images/close-icon.svg" alt="close" />
                                </button>
                            </div>
                            <div class="modal-body" style={{ overflow: "hidden" }}>
                                <div class="row">
                                    <div class="col-md-3 my-3">
                                        <label class="font-14 font-medium w-100 mb-2 color-dark-black">Item ID</label>
                                        <label class="font-14 font-regulars w-100 mb-0 color-light-black">{this.state.selectedItem}</label>
                                    </div>
                                    <div class="col-md-3 my-3">
                                        <label class="font-14 font-medium w-100 mb-2 color-dark-black">Picked quantity</label>
                                        <label class="font-14 font-regulars w-100 mb-0 color-light-black">{this.state.selectedItemQty}</label>
                                    </div>
                                    <div class="col-md-6 mt-5">
                                        <button disabled={this.state.selectedItemQty <= 1} class="btn btn-custom-primary font-12 font-medium px-4" style={{ float: "right" }} onClick={this.addContainer}>
                                            <img class="mr-2" src="images/add-icon.svg" alt="add-icon" />Add container
                                        </button>
                                     </div>
                            <div class="table-responsive mb-4 popup-grid-scroll-style-cnt">
                                <table class="table split-delv-table mb-0 splitContainerBottom">
                                    <thead class="sticky-top">
                                        <tr>
                                            <th>Ship container</th>
                                            <th>Quantity</th>
                                            <th class="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.bindContainers()}
                                    </tbody>
                                </table>
                            </div>
                            <div class="text-right" style={{"marginLeft" : "44%"}}>
                                    <span hidden={this.state.hidePopUpMsg == true ? true : false} class="color-validation font-14 font-regular">The packed quantity is not equal to the picked quantity</span>
                                    </div>
                                    </div>
                                <div className="modal-footer border-0 mt-2 mb-2">
                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" onClick={this.closePopUp} >
                                        Cancel
                            </button>

                                    <button className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => { this.saveContainer() }}>
                                        Save
                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                {/*Modal Ends here*/}
                {/*Remove Popup Modal Starts here*/}
                <div className="modal fade delete-item" tabIndex={-1} role="dialog" id="removePopup" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered custom-delete-width2" role="document">
                        <div className="modal-content py-2">
                            {/*Delete Starts here*/}
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/trash.svg" alt="delete" />
                                        <h5 className="mb-2 font-16 font-bold color-light-black">Confirm</h5>
                                        <p className="mb-1 font-13 font-regular color-light-black">Do you want to Delete all entered Containers?</p>
                                    </div>
                                </div>
                            </div>
                            {/*Delete ends here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button className="btn btn-dark-grey font-14 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">No</button>
                                <button className="btn btn-custom-primary font-14 font-medium mr-2 mb-2 px-4 py-2" onClick={(e) => this.resetCancel("YES")}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Remove Popup Modal Ends here*/}

                {/*Printer Popup starts here*/}
                <div className="modal" id="printerLabelId" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Print Label</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.printBtnClick(e, "cancel")}>
                                    X
                             </button>
                            </div>
                            <div className="modal-body">
                                <div className="col-md-12 my-2">
                                    <div className="row">
                                        <div className="col-md-12 px-0">
                                            <label className="catalog-label mr-2 mt-2">Choose Printer</label>
                                            <div className="col-md-12 mb-3">
                                                <div style={{ "fontSize": "14px" }}>
                                                    <Select
                                                        id="printerId"
                                                        name="printerId"

                                                        options={this.state.printerOptions}
                                                        value={this.state.printerValue}
                                                        onChange={(e) => { this.onChangePrinter(e) }} />
                                                </div>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input release-notes-checkbox" type="checkbox" id="defaultCheck" name="defaultCheck" checked={this.state.defaultCheck} onChange={(e) => this.onChangeHandler("printerCheck", e, "")} />
                                                <label className="form-check-label release-notes-color release-notes-label" htmlFor="defaultCheck">Make Default Printer</label>
                                            </div>

                                        </div>
                                        <div className="col-md-12 mb-3 text-right">
                                            <span className="px-2 errorspan1 mt-3 float-right">{this.state.printerErrorMsg}</span>
                                        </div>
                                        <div className="col-md-12 text-right">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn px-4" data-dismiss="modal" onClick={(e) => this.printBtnClick(e, "cancel")}><Trans>Cancel</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn ml-3 px-4" onClick={(e) => this.printBtnClick(e, "submit")}>Print</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Printer Popup ends here*/}
                {/*Success Popup starts here*/}
                <div className="modal fade success-customer" id="successPopupId" tabIndex={-1} role="dialog" data-backdrop="static" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/tick.svg" alt="tick" />
                                        <p className="mb-1 font-14 font-regular color-light-black">Order Packed and Printed Successfully</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.okClick() }}>OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>

                {/*Success Popup ends here*/}

            </div>
        );
    }
} export default withTranslation()(ContainerPackingComponent);